import classNames from 'classnames';
import React from 'react';
import styles from './list-item-layout.module.css';
export function ListLayout(props) {
    var _a;
    var _b = props.gap, gap = _b === void 0 ? 15 : _b;
    return (React.createElement("ul", { className: classNames(styles.listLayoutChildren, (_a = {}, _a[styles.wrap] = props.wrap, _a), "kplr_listLayoutChildren"), style: { gap: gap } }, props.children));
}
export default ListLayout;
